/*
===========================================
Tech4humans - Custom methods
-------------------------------------------
  Version: 1.0
===========================================
*/

/* ----------------------------------------
 Comparison
 ----------------------------------------*/
export const and = (a, b) => a && b;
export const nand = (a, b) => !(a && b);
export const or = (a, b) => a || b;
export const xor = (a, b) => or(a, b) && nand(a, b);

// Bitwise
export const andB = (a, b) => a & b;
export const nandB = (a, b) => !(a & b);
export const orB = (a, b) => a | b;
export const xorB = (a, b) => orB(a, b) && nandB(a, b);

/* ----------------------------------------
  Types
  ----------------------------------------*/
// not: null, undefined, NaN, empty string (""), false
export const isValid = (el) => el || el === 0;
export const typeOf = (obj, type) => isValid(obj) && typeof obj === type;
export const isArray = (array) => array && Array.isArray(array);
export const isFunction = (func) => typeOf(func, "function");
export const isObject = (obj) => typeOf(obj, "object") && !isArray(obj);
// Exclude NaN
export const isNumber = (num) => typeOf(num, "number");

export function isUndefined(o) {
  return typeof o === "undefined";
}

// Include NaN
// export function isNumber(o) {
//   return typeof o === "number";
// }

export function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}

export function isString(o) {
  return typeof o === "string";
}

export function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}

export function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}

/* ----------------------------------------
  Short version
  ----------------------------------------*/
export const objLength = (ob) => (isObject(ob) ? Object.keys(ob).length : 0);

/* ----------------------------------------
  Array methods
  ----------------------------------------*/
export const findLast = (array, condition) => {
  if (isArray(array) && isFunction(condition)) {
    let last = array.length - 1;
    for (let index = last; index >= 0; index--)
      if (condition(array[index])) return array[index];
  }
  return null;
};

export const sortArrayBy = (array, objKey) => {
  return objKey
    ? array.sort((a, b) =>
        a[objKey].toUpperCase() < b[objKey].toUpperCase()
          ? -1
          : a[objKey].toUpperCase() > b[objKey].toUpperCase()
          ? 1
          : 0
      )
    : array.sort();
};

export const arrayToObj = (array, key) => {
  let response = {};
  if (isArray(array)) {
    if (key) {
      response = array.reduce(
        (obj, item) => ({ ...obj, [item[key]]: item }),
        {}
      );
    } else {
      response = { ...array };
    }
  }
  return response;
};

export const objToArray = (obj, withKey) => {
  let response = [];
  if (isObject(obj)) {
    if (withKey) {
      response = Object.entries(obj).map((e) => ({ [e[0]]: e[1] }));
    } else {
      response = Object.values(obj);
    }
  }
  return response;
};

export const convertSlaTime = (
  _time,
  { fixingSeconds, withSummary } = {
    fixingSeconds: false,
    withSummary: false,
  }
) => {
  if (isNumber(_time)) {
    let timeFormat = _time >= 0 ? "" : "-";
    let timeFormatSummary = _time >= 0 ? "" : "-";
    const time = Math.abs(_time);
    const days = Math.floor(time / 86400);
    const hours = Math.floor((time % 86400) / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60);

    if (days > 0) {
      timeFormat += `${days < 10 ? "0" : ""}${days}d `;
    }

    if (hours > 0) {
      timeFormat += `${hours < 10 ? "0" : ""}${hours}h `;
    }

    if (minutes > 0) {
      timeFormat += `${minutes < 10 ? "0" : ""}${minutes}m `;
    }

    if (seconds > 0) {
      timeFormat += `${seconds < 10 ? "0" : ""}${seconds}s`;
    } else if (fixingSeconds) {
      timeFormat += "00s";
    }

    if (withSummary) {
      if (days > 0) {
        timeFormatSummary += `${days < 10 ? "0" : ""}${days}d `;
      }
      if (hours > 0) {
        timeFormatSummary += `${hours < 10 ? "0" : ""}${hours}h `;
      }
      if (minutes > 0 && (hours === 0 || days === 0)) {
        timeFormatSummary += `${minutes < 10 ? "0" : ""}${minutes}m `;
      }

      if (seconds >= 0) {
        if (seconds >= 0 && (hours === 0 || days === 0) && minutes === 0) {
          timeFormatSummary += `${seconds}s`;
        } else if (days === 0 && hours === 0) {
          timeFormatSummary += `${seconds}s`;
        }
      }

      return {
        full: timeFormat,
        summary: timeFormatSummary,
      };
    }

    return timeFormat;
  }

  return _time;
};

export const getAvailability = (availabilities, avail_id) => {
  if (!isArray(availabilities)) {
    return null;
  }

  const types = {
    away: "Ausente",
    backsoon: "Volto logo",
    online: "Online",
  };
  let availability = availabilities.find((a) => a.id === avail_id);

  if (!availability) {
    availability = availabilities[1]?.children?.find((a) => a.id === avail_id);

    if (!availability) {
      availability = availabilities[2]?.children?.find(
        (a) => a.id === avail_id
      );
    }
  }

  if (!availability) return null;

  return { ...availability, typeInfo: types[availability.type] };
};
